/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PersonsPreviewSelector_persons = ReadonlyArray<{
    readonly id: string;
    readonly fullName: string | null;
    readonly profilePictureId: string | null;
    readonly active: boolean | null;
    readonly permissions: ReadonlyArray<string | null> | null;
    readonly role: {
        readonly name: string | null;
    } | null;
    readonly " $refType": "PersonsPreviewSelector_persons";
}>;
export type PersonsPreviewSelector_persons$data = PersonsPreviewSelector_persons;
export type PersonsPreviewSelector_persons$key = ReadonlyArray<{
    readonly " $data"?: PersonsPreviewSelector_persons$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PersonsPreviewSelector_persons">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PersonsPreviewSelector_persons",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Person"
};
(node as any).hash = 'ea8da9fae671533e2cab39916f27da77';
export default node;
